import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const RoleGuard = ({ children, roles }) => {
  // const { user, loading } = useAuth();
  const user = sessionStorage.getItem('access_token')
  const my_id = sessionStorage.getItem('my_id');
  if (!user) return <Navigate to="/login" />;
  const hasRole = (my_id === roles.toString());
  if (!hasRole) return <Navigate to="/unauthorized" />;
  return children;
};

export default RoleGuard;